<div class="container">
 
        <div>
          <h1 class="title">Contact Me</h1>
            
    <div class="row xs-col-12 md-col-12" data-aos="fade-right">

  <form   class="was-validated" 
  action="https://formspree.io/f/mzbqpebe"
  method="POST">

    <div class="form-row align-items-center">
      <div class="col-auto">
        <label for="validationServer01">Full name</label>
      <input type="text" class="form-control is-valid" name="His Full name" id="validationServer01" placeholder="First name"  required>
      <div class="invalid-feedback">
        <b>!Fratello mio</b>  
      </div>
      </div>
      <div class="col-auto">
        <label for="inputEmail4">Email</label>
        <input type="email" name="His email" class="form-control is-valid" id="inputEmail4" placeholder="Email" required>
        <div class="invalid-feedback">
          unknown@gogo.com
        </div>
      
      </div>
      <div class="col-auto">
    
          <label  for="Message"> Message</label>
          <textarea class="form-control is-valid" name="Message" placeholder="Content" id="Message" required></textarea>
          <div class="invalid-feedback">
            Please Explain your purpose.
          </div>
        </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-primary mb-2">Send</button>
      </div>
    </div>
  
  </form>
